import { render, staticRenderFns } from "./CapacitySetup.vue?vue&type=template&id=a5c30a4a&scoped=true&"
import script from "./CapacitySetup.vue?vue&type=script&lang=js&"
export * from "./CapacitySetup.vue?vue&type=script&lang=js&"
import style0 from "./CapacitySetup.vue?vue&type=style&index=0&id=a5c30a4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c30a4a",
  null
  
)

export default component.exports